var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',_vm._g(_vm._b({directives:[{name:"viewer",rawName:"v-viewer"}],ref:"zmTable",attrs:{"border":_vm.border,"highlight-current-row":_vm.highlightCurrentRow,"stripe":_vm.stripe,"tooltip-effe":_vm.tooltipEffect,"size":_vm.size}},'el-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3487b160","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commons/ZmTable/index.vue
// module id = null
// module chunks = 